module.exports = __webpack_public_path__ + "img/bg9.2aee6a81.png";